import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMountainsBg = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 1672,
	height: 354,
	fill: "none",
	viewBox: "0 0 1672 354",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		fillOpacity: .1,
		d: "M168.535 123.13 33.343 170.895C13.361 177.955 0 196.846 0 218.039v108.867c0 27.785 22.654 50.241 50.438 49.998l1580.002-13.84c27.44-.24 49.56-22.555 49.56-49.998V123.409c0-34.961-34.96-59.129-67.67-46.774l-87.95 33.223c-13.56 5.124-28.66 4.094-41.92-1.783-33.89-15.024-104.82-41.506-175.96-37.23-53.17 3.197-127.16 27.817-161.34 40.124-12.04 4.338-25.28 4.282-37.15-.516l-89.47-36.158a20.04 20.04 0 0 0-16.7.764c-16.927 8.72-55.48 28.433-69.578 34.457-45.478 19.432-126.999-50.899-171.044-93.979-17.83-17.44-45.621-20.839-66.321-6.926L558.952 99.98c-9.198 6.182-20.177 9.114-31.249 8.648-19.182-.806-50.634-1.537-73.524.888-43.518 4.61-102.209 25.511-130.035 36.171-10.379 3.977-21.728 4.709-32.452 1.786l-93.354-25.44a50 50 0 0 0-29.803 1.097"
	})
});
export default SvgMountainsBg;
